module.exports = __webpack_public_path__ + "img/programming.202ef82d.svg";